// shortens meta description for Google without sentence fragments
export default function shortenMetaDescriptionForGoogle(description: string) {
  if (description.length <= 150) {
    return description
  }
  const regex = /[A-Z][^.!?]*[.!?](?=\s+[A-Z])/g
  const descriptionUnderCharacterCount = description.slice(0, 150)
  const sentences = descriptionUnderCharacterCount.match(regex)

  return sentences?.join(' ')
}
